import { gql } from '@apollo/client';
import permissions from 'api/Apollo/permissions';
import useQuery from 'api/hooks/useQuery';
import schema from './schema';
import schemaVersion from './schemaVersion';

export const query = gql`
  query Schema($schemaId: uuid!) {
    schemas_by_pk(id: $schemaId) {
      ...schema
      schemaVersions: schema_versions(order_by: { version: desc }, limit: 1) {
        ...schemaVersion
      }
    }
  }
  ${schema}
  ${schemaVersion}
`;

export default ({ variables, ...options } = {}) => {
  const { data, loading, isAllowed, error } = useQuery(query, {
    variables, // can apply any transforms or default vars here
    context: { permission: permissions.readSchemas },
    // Disabling the cache so we always query the latest version after a schema is edited.
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-and-network',
    ...options, // see https://www.apollographql.com/docs/react/api/react/hooks/ for options
  });

  return {
    data: data?.schemas_by_pk,
    loading,
    isAllowed,
    error,
  };
};
